<template>
    <div>
        <v-row>
            <!-- Main Content -->
            <v-col cols="12" lg="12" md="12" sm="12">
                <v-row>
                    <template v-for="(group, index) in contentGroups">
                        <v-col :class="group.colsClass" :key="`main-${index}`">
                            <template v-for="(item, i) in group.items">
                                <component
                                    :is="item.component"
                                    v-bind="getItemProps(item)"
                                    :key="`item-${index}-${i}`"
                                    :id="item.id"
                                    :title="item.title"
                                    :headingColor="
                                        $_.get(item, 'headingColor', 'primary')
                                    "
                                    :icon="item.icon"
                                    :height="$_.get(item, 'height', '')"
                                    :maxHeight="item.maxHeight"
                                    :class="i > 0 ? 'mt-6' : ''"
                                ></component>
                            </template>
                        </v-col>
                    </template>
                </v-row>
            </v-col>
            <!-- Sidebar Content -->
            <!-- <v-col cols="12" lg="4" md="4" sm="12">
                <template v-for="(item, index) in sideBarItems">
                    <component
                        :is="item.component"
                        v-bind="getItemProps(item)"
                        :headingColor="$_.get(item, 'headingColor', 'primary')"
                        class="mb-6"
                        :key="index"
                        :id="item.id"
                        :title="item.title"
                        :icon="item.icon"
                        :height="$_.get(item, 'height', '')"
                        :maxHeight="item.maxHeight"
                    ></component>
                </template>
            </v-col> -->
        </v-row>
    </div>
</template>

<script>
import ScreeningNotesListing from "@components/screen/components/ScreeningProcessNotesListing";
import ScreeningRentalHistory from "@components/screen/components/ScreeningProcessRentalHistory";
import ScreeningProcessApplicant from "@components/screen/components/ScreeningProcessApplicant";
import ScreeningInvoice from "@components/screen/components/ScreeningProcessInvoice";
import ScreeningEmploymentHistory from "@components/screen/components/ScreeningProcessEmploymentHistory";
import ScreeningProcessCredit from "@components/screen/components/ScreeningProcessCredit";
import ScreeningProcessPublicRecords from "@components/screen/components/ScreeningProcessPublicRecords";
import ScreeningBlank from "@components/screen/components/ScreeningProcessBlank";
import ScreeningNotifications from "@components/screen/components/ScreeningProcessNotifications";
import ScreeningDetails from "@components/screen/components/ScreeningProcessDetails";
import ScreeningFlags from "@components/screen/components/ScreeningProcessFlags";
import ScreeningSummary from "@components/screen/components/ScreeningProcessSummary";
import ScreeningTasks from "@components/screen/components/ScreeningProcessTasks";
import ScreeningActivities from "@components/screen/components/ScreeningProcessActivities";
import ScreeningHousehold from "@components/screen/components/ScreeningProcessHouseholdSummary";
import ScreeningScorecard from "@components/screen/components/ScreeningProcessScorecard";
import ScreeningContacts from "@components/screen/components/ScreeningProcessContacts";
import ScreeningApplication from "@components/screen/components/ScreeningProcessApplication";

export default {
    name: "screening-process-blocks",
    components: {
        ScreeningBlank,
        ScreeningNotifications,
        ScreeningDetails,
        ScreeningFlags,
        ScreeningSummary,
        ScreeningTasks,
        ScreeningActivities,
        ScreeningHousehold,
        ScreeningScorecard,
        ScreeningContacts,
        ScreeningNotesListing,
        ScreeningRentalHistory,
        ScreeningProcessApplicant,
        ScreeningInvoice,
        ScreeningEmploymentHistory,
        ScreeningProcessCredit,
        ScreeningProcessPublicRecords,
        ScreeningApplication,
    },
    props: {
        currentScreen: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        selectedItemId: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            sideBarItems: [],
            contentGroups: [],
        };
    },
    watch: {
        currentScreen: {
            immediate: true,
            handler() {
                this.getSidebarItems();
                this.getContentItems();
            },
        },
    },
    methods: {
        getSidebarItems() {
            this.sideBarItems = this.items.filter(
                (item) =>
                    item.layout === "sidebar" &&
                    item.visible &&
                    // Use a selected Item Id to exclude all other nav items / tiles, convenient for debug and development
                    (item.id === this.selectedItemId || !this.selectedItemId)
            );
        },

        getContentItems() {
            this.items
                .filter(
                    (item) =>
                        item.layout === "main" &&
                        item.visible &&
                        // Use a selected Item Id to exclude all other nav items / tiles, convenient for debug and development
                        (item.id === this.selectedItemId ||
                            !this.selectedItemId)
                )
                .forEach((item) => {
                    // are we grouping this item
                    if (Object.keys(item).includes("group")) {
                        let contentGroup = this.contentGroups.find(
                            (group) => group.code === item.group
                        );
                        if (contentGroup) {
                            contentGroup.items.push(item);
                        } else {
                            this.contentGroups.push({
                                code: item.group,
                                colsClass: item.colsClass,
                                items: [item],
                            });
                        }
                    } else {
                        this.contentGroups.push({
                            code: "",
                            colsClass: item.colsClass,
                            items: [item],
                        });
                    }
                });
        },
        getItemProps({ id, title, icon, params }) {
            let props = {};
            for (const key in params) {
                props[key] = this.$_.get(this.currentScreen, params[key]);
            }
            return {
                ...props,
                id,
                title,
                icon,
            };
        },
    },
    created() {},
    mounted() {
        this.$emit("init");
    },
};
</script>

<style lang="scss" scoped>
</style>